(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart_drawer"]) return;
  try {
    
  const handleLoad = async () => {
    const cartDrawer = document.querySelector('.cart_drawer')
    if (!cartDrawer) return
    cartDrawer.classList.remove('firstLoadHidden')
  }
  document.addEventListener("DOMContentLoaded", handleLoad)

  } catch(e) { console.error(e); }
})();
})();
